import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Background from "../login/_background";
import { agencyLogin } from "../../services/agencyService";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { useAppDispatch } from "../../redux/store";

const AgencyLoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [agencyId, setAgencyId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(loaderActions.showLoader());
    setError("");

    const response = await agencyLogin(agencyId, password);

    if (response && response.success) {
      sessionStorage.setItem("agencyAuthenticated", "true");
      sessionStorage.setItem("agencyId", agencyId);
      dispatch(loaderActions.hideLoader());
      navigate("/agency/dashboard");
    } else {
      dispatch(loaderActions.hideLoader());
      setError("Invalid agency number or password");
    }
  };

  return (
    <div className="w-screen h-screen relative">
      <Background />

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-5/6 md:w-3/6 lg:w-2/6 space-y-3">
        <form
          onSubmit={onSubmit}
          className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg space-y-4"
        >
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
            Agency Login
          </h2>

          {error && (
            <div className="text-red-500 text-center text-sm">{error}</div>
          )}

          <TextField
            label="Agency Number"
            variant="outlined"
            fullWidth
            value={agencyId}
            onChange={(e) => setAgencyId(e.target.value)}
            required
          />

          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            className="bg-blue-600 hover:bg-blue-700 py-2"
          >
            Login
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AgencyLoginPage;
